import { initial } from "lodash";

const initialState = {
  isAuth: false,

  user: {
    firstName: null,
    lastName: null,
    roleId: null,
  },

  completedStatus: [
    "Outstanding",
    "Completed by technician",
    "Closed by office",
  ],
  workStatus: ["Completed by technician", "Closed by office"],

  contracts: [],
  contractAddresses: [],
  counties: {},
  routes: {},
  municipalities: [],
  habitats: [],
  waters: {},
  trapTypes: [],
  trapNights: {},
  trapTeams: {},
  subdivisions: {},
  requestTypes: {},
  mosquitoes: [],
  applicators: {},
  states: {},
  achemicals: {},
  mixRatios: {},
  windDirections: {},
  aEquipment: {},
  vizualMonitors: {},
  adultAppRates: {},
  assays: {},
  results: {},
  lEquipment: {},
  controlAction: {},
  lChemicals: {},
  zones: {},
  sites: [],
  larvaCounts: {},
  larvalAppRates: {},
  siteSearch: {
    loading: false,
    sites: [],
    selected: { site: {}, trapSite: {} },
  },
  trucks: {},
  sitesTotalPages: 0,
  sitesPagesLoaded: 0,
  allNonSitesDataLoaded: false,
};

export const state = _.cloneDeep(initialState);

export const getters = {
  isAdmin: (state) => {
    return state.user.roleId == "Admin";
  },
  isContract: (state) => {
    return state.user.roleId == "Contract";
  },

  contractsEmpty: (state) => {
    return Object.keys(state.contracts).length == 0;
  },

  contracts: (state) => {
    return state.contracts;
  },

  contractAddresses: (state) => {
    return state.contractAddresses;
  },

  forSelect: (state) => (object, field = "name") => {
    let select = state[object].map((o) => {
      return { id: o.id, name: o.attributes[field] };
    });

    select.unshift({ id: "all", name: "All" });

    return select;
  },

  counties: (state) => {
    return state.counties;
  },

  routes: (state) => {
    return state.routes;
  },

  municipalities: (state) => {
    return state.municipalities;
  },

  habitats: (state) => {
    return state.habitats;
  },

  waters: (state) => {
    return state.waters;
  },

  trapNights: (state) => {
    return state.trapNights;
  },

  trapTeams: (state) => {
    return state.trapTeams;
  },

  trapTypes: (state) => {
    return state.trapTypes;
  },

  subdivisions: (state) => {
    return state.subdivisions;
  },

  requestTypes: (state) => {
    return state.requestTypes;
  },

  mosquitoSpecies: (state) => {
    return state.mosquitoes;
  },

  applicators: (state) => {
    return state.applicators;
  },

  states: (state) => {
    return state.states;
  },

  completedStatus: (state) => {
    return state.completedStatus;
  },

  workStatus: (state) => {
    return state.workStatus;
  },

  achemicals: (state) => {
    return state.achemicals;
  },

  trucks: (state) => {
    return state.trucks;
  },

  mixRatios: (state) => {
    return state.mixRatios;
  },

  windDirections: (state) => {
    return state.windDirections;
  },

  aEquipment: (state) => {
    return state.aEquipment;
  },

  vizualMonitors: (state) => {
    return state.vizualMonitors;
  },

  adultAppRates: (state) => {
    return state.adultAppRates;
  },

  assays: (state) => {
    return state.assays;
  },

  results: (state) => {
    return state.results;
  },

  lEquipment: (state) => {
    return state.lEquipment;
  },

  controlActions: (state) => {
    return state.controlAction;
  },

  lChemicals: (state) => {
    return state.lChemicals;
  },

  zones: (state) => {
    return state.zones;
  },

  sites: (state) => {
    return state.sites;
  },

  sitesTotalPages: (state) => {
    return state.sitesTotalPages;
  },

  sitesPagesLoaded: (state) => {
    return state.sitesPagesLoaded;
  },

  allNonSitesDataLoaded: (state) => {
    return state.allNonSitesDataLoaded;
  },

  larvaCounts: (state) => {
    return state.larvaCounts;
  },

  larvalAppRates: (state) => {
    return state.larvalAppRates;
  },

  siteSearch: (state) => {
    return state.siteSearch;
  },

  contractNameById: (state) => (id) => {
    let contract = _.find(state.contracts, ["id", id]);
    if (contract) {
      return contract.attributes.name;
    } else {
      return null;
    }
  },

  contractAddressById: (state) => (id) => {
    let contract = _.find(state.contractAddresses, ["id", id]);
    if (contract) {
      return contract.attributes.address;
    } else {
      return null;
    }
  },

  routeNameById: (state) => (id) => {
    let route = _.find(state.routes, ["id", id]);
    if (route) {
      return route.attributes.name;
    } else {
      return null;
    }
  },

  countyNameById: (state) => (id) => {
    let county = _.find(state.counties, ["id", id]);
    if (county) {
      return county.attributes.name;
    } else {
      return null;
    }
  },

  municipalityNameById: (state) => (id) => {
    let municipality = _.find(state.municipalities, ["id", id]);
    if (municipality) {
      return municipality.attributes.name;
    } else {
      return null;
    }
  },

  municipalityIdByName: (state) => (name) => {
    let municipality = _.find(state.municipalities, ["attributes.name", name]);
    if (municipality) {
      return municipality.id;
    } else {
      return null;
    }
  },

  habitatNameById: (state) => (id) => {
    let habitat = _.find(state.habitats, ["id", id]);
    if (habitat) {
      return habitat.attributes.name;
    } else {
      return null;
    }
  },

  waterNameById: (state) => (id) => {
    let water = _.find(state.waters, ["id", id]);
    if (water) {
      return water.attributes.name;
    } else {
      return null;
    }
  },

  trapTypeNameById: (state) => (id) => {
    let item = _.find(state.trapTypes, ["id", id]);
    if (item) {
      return item.attributes.trap;
    } else {
      return null;
    }
  },

  trapNightNameById: (state) => (id) => {
    let item = _.find(state.trapNights, ["id", id]);
    if (item) {
      return item.attributes.name;
    } else {
      return null;
    }
  },

  trapTeamNameById: (state) => (id) => {
    let item = _.find(state.trapTeams, ["id", id]);
    if (item) {
      return item.attributes.name;
    } else {
      return null;
    }
  },

  subdivisionNameById: (state) => (id) => {
    let item = _.find(state.subdivisions, ["id", id]);
    if (item) {
      return item.attributes.name;
    } else {
      return null;
    }
  },

  requestTypeNameById: (state) => (id) => {
    let item = _.find(state.requestTypes, ["id", id]);
    if (item) {
      return item.attributes.kind;
    } else {
      return null;
    }
  },

  mosquitoNameById: (state) => (id) => {
    let item = _.find(state.mosquitoes, ["id", id]);
    if (item) {
      return item.attributes.name;
    } else {
      return null;
    }
  },

  applicatorNameById: (state) => (id) => {
    let item = _.find(state.applicators, ["id", id]);
    if (item) {
      return item.attributes.inspector;
    } else {
      return null;
    }
  },

  applicatorIdByName: (state) => (name) => {
    let item = _.find(state.applicators, ["attributes.inspector", name]);
    if (item) {
      return item.id;
    } else {
      return null;
    }
  },

  getApplicatorLicense: (state) => (id) => {
    let item = _.find(state.applicators, ["id", id]);
    if (item) {
      return item.attributes.license;
    } else {
      return null;
    }
  },

  stateNameById: (state) => (id) => {
    let item = _.find(state.states, ["id", id]);
    if (item) {
      return item.attributes.name;
    } else {
      return null;
    }
  },

  achemicalNameById: (state) => (id) => {
    let item = _.find(state.achemicals, ["id", id]);
    if (item) {
      return item.attributes.chemName;
    } else {
      return null;
    }
  },

  achemicalIdByName: (state) => (name) => {
    let item = _.find(state.achemicals, ["attributes.chemName", name]);
    if (item) {
      return item.id;
    } else {
      return null;
    }
  },

  trucksNameById: (state) => (id) => {
    let item = _.find(state.trucks, ["id", id]);
    if (item) {
      return item.attributes.name;
    } else {
      return null;
    }
  },

  trucksIdByName: (state) => (name) => {
    let item = _.find(state.trucks, ["attributes.name", name]);
    if (item) {
      return item.id;
    } else {
      return null;
    }
  },

  mixRatioNameById: (state) => (id) => {
    let item = _.find(state.mixRatios, ["id", id]);
    if (item) {
      return item.attributes.ratio;
    } else {
      return null;
    }
  },

  mixRatioIdByName: (state) => (ratio) => {
    let item = _.find(state.mixRatios, ["attributes.ratio", ratio]);
    if (item) {
      return item.id;
    } else {
      return null;
    }
  },

  windDirectionNameById: (state) => (id) => {
    let item = _.find(state.windDirections, ["id", id]);
    if (item) {
      return item.attributes.direction;
    } else {
      return null;
    }
  },

  windDirectionIdByName: (state) => (direction) => {
    let item = _.find(state.windDirections, [
      "attributes.direction",
      direction,
    ]);
    if (item) {
      return item.id;
    } else {
      return null;
    }
  },

  aEquipementNameById: (state) => (id) => {
    let item = _.find(state.aEquipment, ["id", id]);
    if (item) {
      return item.attributes.appType;
    } else {
      return null;
    }
  },

  vizualMonitorNameById: (state) => (id) => {
    let item = _.find(state.vizualMonitors, ["id", id]);
    if (item) {
      return item.attributes.reason;
    } else {
      return null;
    }
  },

  vizualMonitorIdByName: (state) => (reason) => {
    let item = _.find(state.vizualMonitors, (item) => {
      return item.attributes.reason.toLowerCase() == reason.toLowerCase();
    });
    if (item) {
      return item.id;
    } else {
      return null;
    }
  },

  adultAppRatesNameById: (state) => (id) => {
    let item = _.find(state.adultAppRates, ["id", id]);
    if (item) {
      return item.attributes.apprate;
    } else {
      return null;
    }
  },

  adultAppRatesIdByName: (state) => (rate) => {
    let item = _.find(state.adultAppRates, (item) => {
      return item.attributes.apprate.toLowerCase() == rate.toLowerCase();
    });
    if (item) {
      return item.id;
    } else {
      return null;
    }
  },

  assaysNameById: (state) => (id) => {
    let item = _.find(state.assays, ["id", id]);
    if (item) {
      return item.attributes.assay;
    } else {
      return null;
    }
  },

  resultsNameById: (state) => (id) => {
    let item = _.find(state.results, ["id", id]);
    if (item) {
      return item.attributes.result;
    } else {
      return null;
    }
  },

  lEquipementNameById: (state) => (id) => {
    let item = _.find(state.lEquipment, ["id", id]);
    if (item) {
      return item.attributes.kind;
    } else {
      return null;
    }
  },

  controlActionNameById: (state) => (id) => {
    let item = _.find(state.controlAction, ["id", id]);
    if (item) {
      return item.attributes.name;
    } else {
      return null;
    }
  },

  lChemicalNameById: (state) => (id) => {
    let item = _.find(state.lChemicals, ["id", id]);
    if (item) {
      return item.attributes.chemName;
    } else {
      return null;
    }
  },

  zoneNameById: (state) => (id) => {
    let item = _.find(state.zones, ["id", id]);
    if (item && item.attributes) {
      return item.attributes.name;
    } else {
      return null;
    }
  },

  zoneIdByName: (state) => (name) => {
    let item = _.find(state.zones, ["attributes.name", name]);
    if (item) {
      return item.id;
    } else {
      return null;
    }
  },

  siteNameById: (state) => (id) => {
    let item = _.find(state.sites, ["id", id]);
    if (item) {
      return item.attributes.name;
    } else {
      return null;
    }
  },

  larvaCountNameById: (state) => (id) => {
    let item = _.find(state.larvaCounts, ["id", id]);
    if (item) {
      return item.attributes.count;
    } else {
      return null;
    }
  },

  larvalAppRateNameById: (state) => (id) => {
    let item = _.find(state.larvalAppRates, ["id", id]);
    if (item) {
      return item.attributes.apprate;
    } else {
      return null;
    }
  },
};

export const actions = {
  loggedIn({ commit }) {
    commit("auth", true);
  },

  loggedOut({ commit }) {
    commit("auth", false);
  },

  setUser({ commit }, payload) {
    commit("setUser", payload);
  },

  setContracts({ commit }, payload) {
    commit("setContracts", payload);
  },

  setContractAddresses({ commit }, payload) {
    commit("setContractAddresses", payload);
  },

  setCounties({ commit }, payload) {
    commit("setCounties", payload);
  },

  setRoutes({ commit }, payload) {
    commit("setRoutes", payload);
  },

  setMunicipalities({ commit }, payload) {
    commit("setMunicipalities", payload);
  },

  setHabitats({ commit }, payload) {
    commit("setHabitats", payload);
  },

  setWaters({ commit }, payload) {
    commit("setWaters", payload);
  },

  setTrapTeams({ commit }, payload) {
    commit("setTrapTeams", payload);
  },

  setTrapTypes({ commit }, payload) {
    commit("setTrapTypes", payload);
  },

  setTrapNights({ commit }, payload) {
    commit("setTrapNights", payload);
  },

  setSubdivisions({ commit }, payload) {
    commit("setSubdivisions", payload);
  },

  setRequestType({ commit }, payload) {
    commit("setRequestTypes", payload);
  },

  setMosquitoes({ commit }, payload) {
    commit("setMosquitoes", payload);
  },

  setApplicators({ commit }, payload) {
    commit("setApplicators", payload);
  },

  setStates({ commit }, payload) {
    commit("setStates", payload);
  },

  setAchemicals({ commit }, payload) {
    commit("setAchemicals", payload);
  },

  setTrucks({ commit }, payload) {
    commit("setTrucks", payload);
  },

  setMixRatio({ commit }, payload) {
    commit("setMixRatio", payload);
  },

  setWindDirections({ commit }, payload) {
    commit("setWindDirections", payload);
  },

  setAequipment({ commit }, payload) {
    commit("setAequipment", payload);
  },

  setVizualMonitors({ commit }, payload) {
    commit("setVizualMonitors", payload);
  },

  setAdultAppRates({ commit }, payload) {
    commit("setAdultAppRates", payload);
  },

  setAssays({ commit }, payload) {
    commit("setAssays", payload);
  },

  setResults({ commit }, payload) {
    commit("setResults", payload);
  },

  setLequipment({ commit }, payload) {
    commit("setLequipment", payload);
  },

  setControlAction({ commit }, payload) {
    commit("setControlAction", payload);
  },

  setLchemicals({ commit }, payload) {
    commit("setLchemicals", payload);
  },

  setZones({ commit }, payload) {
    commit("setZones", payload);
  },

  setSraOptions({ commit }, payload) {
    commit("setSraOptions", payload);
  },

  setSites({ commit }, payload) {
    commit("setSites", payload);
  },

  setSitesPagesLoaded({ commit }, payload) {
    commit("setSitesPagesLoaded", payload);
  },

  setSitesTotalPages({ commit }, payload) {
    commit("setSitesTotalPages", payload);
  },

  setAllNonSitesDataLoaded({ commit }, payload) {
    commit("setAllNonSitesDataLoaded", payload);
  },

  setLarvaCounts({ commit }, payload) {
    commit("setLarvaCounts", payload);
  },

  setLarvalAppRates({ commit }, payload) {
    commit("setLarvalAppRates", payload);
  },

  reset({ commit }) {
    commit("reset");
  },

  setSiteSearchLoading({ commit }, payload) {
    commit("setSiteSearchLoading", payload);
  },

  setSiteSearchResults({ commit }, payload) {
    commit("setSiteSearchResults", payload);
  },

  setSiteSearchSelected({ commit }, payload) {
    commit("setSiteSearchSelected", payload);
  },

  setSiteSearchClear({ commit }) {
    commit("setSiteSearchClear");
  },
};

export const mutations = {
  auth(state, x) {
    state.isAuth = x;
  },

  setUser(state, user) {
    state.user = user;
  },

  clearUser(state) {
    state.user = null;
  },

  setContracts(state, contracts) {
    state.contracts = contracts;
  },

  setContractAddresses(state, addresses) {
    state.contractAddresses = addresses;
  },

  setCounties(state, counties) {
    state.counties = counties;
  },

  setRoutes(state, routes) {
    state.routes = routes;
  },

  setMunicipalities(state, municipalities) {
    state.municipalities = municipalities;
  },

  setHabitats(state, habitats) {
    state.habitats = habitats;
  },

  setWaters(state, waters) {
    state.waters = waters;
  },

  setTrapTeams(state, traps) {
    state.trapTeams = traps;
  },

  setTrapTypes(state, traps) {
    state.trapTypes = traps;
  },

  setTrapNights(state, traps) {
    state.trapNights = traps;
  },

  setSubdivisions(state, subdivisions) {
    state.subdivisions = subdivisions;
  },

  setRequestTypes(state, types) {
    state.requestTypes = types;
  },

  setMosquitoes(state, types) {
    state.mosquitoes = types;
  },

  setApplicators(state, applicators) {
    state.applicators = applicators;
  },

  setStates(state, states) {
    state.states = states;
  },

  setAchemicals(state, chemicals) {
    state.achemicals = chemicals;
  },

  setTrucks(state, trucks) {
    state.trucks = trucks;
  },

  setMixRatio(state, ratios) {
    state.mixRatios = ratios;
  },

  setWindDirections(state, ratios) {
    state.windDirections = ratios;
  },

  setAequipment(state, equipment) {
    state.aEquipment = equipment;
  },

  setVizualMonitors(state, monitors) {
    state.vizualMonitors = monitors;
  },

  setAdultAppRates(state, adult) {
    state.adultAppRates = adult;
  },

  setAssays(state, assay) {
    state.assays = assay;
  },

  setResults(state, results) {
    state.results = results;
  },

  setLequipment(state, equipment) {
    state.lEquipment = equipment;
  },

  setControlAction(state, action) {
    state.controlAction = action;
  },

  setLchemicals(state, chemical) {
    state.lChemicals = chemical;
  },

  setZones(state, zones) {
    state.zones = zones;
  },

  setSraOptions(state, sraOptions) {
    state.sraOptions = sraOptions;
  },

  setSites(state, sites) {
    state.sites = [...state.sites, ...sites];
  },

  setSitesPagesLoaded(state, pages) {
    state.sitesPagesLoaded = pages;
  },

  setSitesTotalPages(state, pages) {
    state.sitesTotalPages = pages;
  },

  setAllNonSitesDataLoaded(state, status) {
    state.allNonSitesDataLoaded = status;
  },

  setLarvaCounts(state, counts) {
    state.larvaCounts = counts;
  },

  setLarvalAppRates(state, rates) {
    state.larvalAppRates = rates;
  },

  reset(state) {
    Object.assign(state, _.cloneDeep(initialState));
  },

  setSiteSearchLoading(state, status) {
    state.siteSearch.loading = status;
  },

  setSiteSearchResults(state, results) {
    state.siteSearch.sites = results;
    if (results.length) {
      state.siteSearch.selected = results[0].attributes;
    } else {
      state.siteSearch.selected = initialState.siteSearch.selected;
    }
  },

  setSiteSearchSelected(state, id) {
    let site = _.find(state.siteSearch.sites, ["id", id]);
    if (site) {
      state.siteSearch.selected = site.attributes;
    } else {
      state.siteSearch.selected = initialState.siteSearch.selected;
    }
  },

  setSiteSearchClear(state) {
    // state.siteSearch = initialState.siteSearch isn't working for some reason, so I have to reset them individually
    state.siteSearch.loading = false;
    state.siteSearch.sites = [];
    state.siteSearch.selected = { site: {}, trapSite: {} };
  },
};
